import axios from 'axios'
import { useFormik } from 'formik'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getBackendUrl } from '../../../api'
import { useSnackbar } from '../../../providers/SnackbarProvider'

const SERVER_URL = getBackendUrl()
// const id = 123;
const useBookings = () => {
    //todo on submit change query parma with bookingId rand status - navigate(url,{
    // replace:true
    // })
    const [bookings, setBookings] = useState([])
    const navigate = useNavigate()
    const { showSnackbar } = useSnackbar()
    const [searchParams] = useSearchParams()
    const [loading, setLoading] = useState(false)

    const form = useFormik({
        initialValues: {
            bookingId: '',
            status: 'none',
        },
        onSubmit: (values) => {
            const sp = new URLSearchParams()
            if (values.bookingId === '') {
                sp.delete('bookingId')
            } else {
                sp.set('bookingId', values.bookingId)
            }
            if (values.status === 'none') {
                sp.delete('status')
            } else {
                sp.set('status', values.status)
            }
            navigate(`/bookings?${sp.toString()}`, {
                replace: true,
            })
            fetchBookings(sp)
        },
    })

    const fetchBookings = useCallback(
        async (searchParams) => {
            setLoading(true)
            try {
                const { data, status } = await axios.get(`${SERVER_URL}/customers/bookings?${searchParams.toString()}`)
                if (status === 200) {
                    setBookings(data.payload.response.bookings)
                }
            } catch (errors) {
                showSnackbar({
                    msg: errors.response.data.developerInfo,
                    sev: 'error',
                })
            }
            setLoading(false)
        },
        [showSnackbar]
    )

    useEffect(() => {
        if (searchParams.get('bookingId') || searchParams.get('status')) {
            form.setValues({
                status: searchParams.get('status') || 'none',
                bookingId: searchParams.get('bookingId') || '',
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        fetchBookings(searchParams)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleCreateBooking = useCallback(() => {
        navigate(`/bookings/create`)
    }, [navigate])

    return useMemo(
        () => ({
            form: form,
            bookings: bookings,
            handleCreateBooking: handleCreateBooking,
            loading: loading,
        }),
        [form, bookings, handleCreateBooking, loading]
    )
}

export default useBookings
